export const ShopByCategoryMap = [
  {
    id: 1,
    src: './img/category-phones.png',
    title: 'Mobile phones',
    path: '/phones',
  },
  {
    id: 2,
    src: './img/category-tablets.png',
    title: 'Tablets',
    path: '/tablets',
  },
  {
    id: 3,
    src: './img/category-accessories.png',
    title: 'Accessories',
    path: '/accessories',
  },
];
